import type { FaireProductEntity } from "../../entity_types/product";

export const p_d25824f3s6: FaireProductEntity = {
  token: "p_d25824f3s6",
  type: "product",
  name: "Cool Black Cat Pattern Socks from the Socks Panda (Adult Medium)",
  brandToken: "b_hshp7p463w",
  brandName: "Sock Panda",
  imageUrl:
    "https://cdn.faire.com/fastly/5e96cdd0468614872869946614936123a09be1d0160ed90e4ccb4e5134eefed0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b790ccf7af7f8d612d46edc0f2f89b3e5c169ffb9f3ae91c53ab9efaa2e0a882.jpeg",
    "https://cdn.faire.com/fastly/df3b97fc16099fc83f95fae16a19bf12c36a650ade5dc493b84c33b8abca6d7a.jpeg",
    "https://cdn.faire.com/fastly/482b36db22a6a76c694c26c5a86d40ae5c900cbed14029531869554f962ed8ec.jpeg",
    "https://cdn.faire.com/fastly/ae265d9d5d65546d938fea670e51590fac8508bb3a38057b8af99206de190203.jpeg",
  ],
  priceDollars: 4.75,
  description:
    "Women Shoe Sizes 5-10 (Adult Medium)\n\nBlack cats are really cool, especially amongst a couple of other colored cats. Great socks.\n\n * 85% Peruvian Cotton, 10% Polyester, 5% Spandex \n *  Attention getting design - Guaranteed to start a conversation \n *  Up your Sock Game with these fun socks! \n *  High quality fabric that will not rip or tear - Very Comfortable \n * Best if washed in cold water \n\n\nWith your purchase, the Sock Panda donates socks to someone in need.\n\nThank you!\n",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:37.720Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
